import { render, staticRenderFns } from "./CardCadastroCliente.vue?vue&type=template&id=fa69f3da&scoped=true"
import script from "./CardCadastroCliente.vue?vue&type=script&lang=js"
export * from "./CardCadastroCliente.vue?vue&type=script&lang=js"
import style0 from "./CardCadastroCliente.vue?vue&type=style&index=0&id=fa69f3da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa69f3da",
  null
  
)

export default component.exports